export const ALL_GENRES: Genre[] = [
  { id: 0, name: "Any" },
  { id: 28, name: "Action" },
  { id: 12, name: "Adventure" },
  { id: 35, name: "Comedy" },
  { id: 18, name: "Drama" },
  { id: 99, name: "Documentary" },
  { id: 14, name: "Fantasy" },
  { id: 27, name: "Horror" },
  { id: 878, name: "Science Fiction" },
];

export type Genre = {
    id: number,
    name: string
}